import { gql } from "@apollo/client";

export const CARD_STATUS = gql`
  query getHavePaymentMethod {
    getHavePaymentMethod {
      haveCard,
      locationSquareId,
      success,
      messages,
    }
  }
`;
